import React, { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';

interface ConfettiAnimationProps {
  isActive: boolean;
  onComplete?: () => void;
}

const ConfettiAnimation: React.FC<ConfettiAnimationProps> = ({
  isActive,
  onComplete
}) => {
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (isActive && !hasTriggered.current) {
      hasTriggered.current = true;
      
      // Create a celebratory confetti burst
      const count = 200;
      const defaults = {
        origin: { y: 0.7 }
      };

      const fire = (particleRatio: number, opts: any) => {
        confetti({
          ...defaults,
          ...opts,
          particleCount: Math.floor(count * particleRatio)
        });
      };

      // Fire multiple bursts for a more dramatic effect
      fire(0.25, {
        spread: 26,
        startVelocity: 55,
        colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#f0932b']
      });
      
      fire(0.2, {
        spread: 60,
        colors: ['#eb4d4b', '#6c5ce7', '#a29bfe', '#fd79a8', '#fdcb6e']
      });
      
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
        colors: ['#ff9ff3', '#54a0ff', '#5f27cd', '#00d2d3', '#ff9f43']
      });
      
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
        colors: ['#f368e0', '#ff3838', '#ff9500', '#ffd700', '#32ff7e']
      });
      
      fire(0.1, {
        spread: 120,
        startVelocity: 45,
        colors: ['#7158e2', '#3742fa', '#2f3542', '#ff4757', '#ffc048']
      });

      // Call onComplete after a delay to allow animation to finish
      if (onComplete) {
        setTimeout(() => {
          onComplete();
          hasTriggered.current = false; // Reset for next time
        }, 3000);
      } else {
        // Reset for next time even if no onComplete callback
        setTimeout(() => {
          hasTriggered.current = false;
        }, 3000);
      }
    }
  }, [isActive, onComplete]);

  return null; // Canvas confetti doesn't need a DOM element
};

export default ConfettiAnimation;